"use client";

import Header from "../../layouts/Header";
import { ArrowLeft } from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Separator } from "../../components/ui/separator";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function SettingsProfile() {
  const { userProfile } = useAuth();
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col h-screen">
        <div className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white">
          <button href="/settings-section">
            <div
              className="mr-5 rounded-full p-1 border"
              onClick={() => {
                navigate("/settings/index");
              }}
            >
              <ArrowLeft size={14} />
            </div>
          </button>
          <p
            className="text-sm font-medium mr-1 underline  text-[16px]"
            onClick={() => {
              navigate("/settings/index");
            }}
          >
            Settings
          </p>
          <p className="text-sm font-medium mr-1  text-[16px]"> / </p>
          <p className="text-sm text-purp font-medium  text-[16px]">Profile</p>
        </div>

        <div className="flex justify-center mt-12 px-4 md:px-16 lg:px-32">
          <div className="max-w-3xl w-full">
            <Card className="bg-white rounded-2xl shadow-sm overflow-hidden">
              <CardHeader className="px-9 pt-6 pb-4">
                <CardTitle className="text-2xl font-semibold text-text-secondary text-[20px]">
                  Profile
                </CardTitle>
              </CardHeader>

              <CardContent className="px-20 pt-5 pb-10">
                {userProfile ? (
                  <div className="grid grid-cols-2 gap-x-4 gap-y-10 text-sm text-gray-700">
                    <div>
                      <p className="font-semibold text-text-primary text-[16px]">
                        Name
                      </p>
                      <p className="font-normal text-text-secondary text-[16px] mt-[15px]">
                        {typeof userProfile.personal_info.name === "string"
                          ? userProfile.personal_info.name
                          : "N/A"}
                      </p>
                    </div>
                    <div className="">
                      <p className="font-semibold text-text-primary text-[16px]">
                        Surname
                      </p>
                      <p className="font-normal text-text-secondary text-[16px] mt-[15px]">
                        {typeof userProfile.personal_info.lastname === "string"
                          ? userProfile.personal_info.lastname
                          : "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="font-semibold text-text-primary text-[16px]">
                        Email
                      </p>
                      <p className="font-normal text-text-secondary text-[16px] mt-[15px]">
                        {typeof userProfile.email === "string"
                          ? userProfile.email
                          : "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="font-semibold text-text-primary text-[16px]">
                        Mobile number
                      </p>
                      <p className="font-normal text-text-secondary text-[16px] mt-[15px]">
                        {typeof userProfile.personal_info.phoneNumber ===
                        "string"
                          ? userProfile.personal_info.phoneNumber
                          : "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="font-semibold text-text-primary text-[16px]">
                        Country of residence
                      </p>
                      <p className="font-normal text-text-secondary text-[16px] mt-[15px]">
                        {typeof userProfile.address.country === "string"
                          ? userProfile.address.country
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                ) : (
                  <p className="text-sm text-gray-500">
                    Loading user information...
                  </p>
                )}
              </CardContent>

              <Separator />

              <div className="py-4 text-center text-sm text-gray-500  text-[16px]">
                Need to update your details?{" "}
                <a
                  href="/support/index"
                  className="text-rose-600 font-bold hover:underline cursor-pointer"
                >
                  Contact us
                </a>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
